import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const KEY = "ff-install-dismissed";
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallBanner = () => {
  const [prompt, setPrompt] = useState(null);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
    if (standalone() || localStorage.getItem(KEY)) {
      return undefined;
    }
    if (isIos()) setIos(true);
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setPrompt(null);
    setIos(false);
  };

  const install = async () => {
    prompt.prompt();
    await prompt.userChoice;
    dismiss();
  };

  if (!prompt && !ios) return null;
  return (
    <div data-testid="install-banner" className="fixed left-3 right-3 bottom-24 md:bottom-5 md:left-auto md:right-5 md:w-[380px] z-40 ff-glass-panel rounded-2xl border border-[#10B981]/50 p-4 flex items-center gap-3 ff-rise">
      <img src="/icons/icon-192.png" alt="" className="h-11 w-11 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-extrabold text-white">Aggiungi FLEETFLOW alla Schermata Home</p>
        <p data-testid="install-banner-text" className="text-xs text-[#CBD5E1]">
          {ios ? <>Tocca <Share size={12} className="inline -mt-0.5" /> Condividi, poi “Aggiungi a Home”.</> : "Apri la bacheca come un'app vera, con notifiche."}
        </p>
      </div>
      {prompt && <button type="button" data-testid="install-banner-button" onClick={install} className="ff-btn-primary !min-h-[44px] px-3 text-xs uppercase shrink-0"><Download size={15} /> Installa</button>}
      <button type="button" data-testid="install-banner-dismiss" aria-label="Chiudi" onClick={dismiss} className="text-[#94A3B8] hover:text-white p-1 shrink-0"><X size={18} /></button>
    </div>
  );
};
